export const ON_SCHEDULE = 0
export const PAST_DUE = 1
export const COMPLETED = 2
export const COMPLETED_BUT_NOT_IN_TIME = 3

export const NORMAL_PRIORITY = 0
export const HIGH_PRIORITY = 1

let taskStatues = new Map()
taskStatues.set(0, 'On Schedule')
taskStatues.set(1, 'Past Due')
taskStatues.set(2, 'Completed')
taskStatues.set(3, 'Completed, but not on time!')

let taskPriority = new Map()
taskPriority.set(0, 'Normal')
taskPriority.set(1, 'High Priority')

export const getStatusName = (id) => {
  return taskStatues.get(id)
}

export const getPriorityName = (id) => {
  return taskPriority.get(id)
}

export const TaskTypesOptions = [
  { name: 'All Tasks', value: null },
  { name: 'Past Due Tasks', value: 1 },
  { name: 'Due Now Tasks', value: 2 },
  { name: 'Meetings Only', value: 3 },
]

// NEXT STEP CONSTANTS
export const NO_ANSWER_CALL_BACK_2_HOURS = 10001
export const FOLLOW_UP_PER_POLICY = 10002
export const FOLLOW_UP_TOMORROW = 10003
export const FOLLOW_UP_NEXT_WEEK = 10004
export const NONE = 10005
